import { Box, Flex, HStack, Stack, StackDivider, Text } from "@chakra-ui/react";
import React from "react";
import { BiEdit } from "react-icons/bi";

export default function WorkHistory() {
  return (
    <Box border="1px solid #c5c5c5" borderRadius={10} overflow="hidden" my={8}>
      <Flex
        bg="#f1f1f1"
        justifyContent="space-between"
        p={4}
        fontWeight="medium"
        borderBottom={"1px"}
        borderColor="#c5c5c5"
      >
        <Text fontSize={{ base: "18px", md: "22px" }}>Work History</Text>
      </Flex>
      <Stack p={8} gap={4} divider={<StackDivider />}>
        {["1", "2", "3", "4"].map((item) => {
          return (
            <Flex
              gap={2}
              key={item}
              justifyContent={"space-between"}
              fontWeight={"medium"}
              mb={3}
              alignItems="start"
              flexDir={{ base: "column", sm: "row" }}
            >
              <Stack>
                <Text
                  color="black"
                  fontSize={{ base: "19px", lg: "26px" }}
                  fontWeight="medium"
                >
                  Creative Director | DRX USA
                </Text>
                <Text
                  fontWeight={"medium"}
                  color="#888"
                  fontSize={{ base: "14px", xl: "20px" }}
                >
                  April 2016 - September 2016
                </Text>
              </Stack>
              <HStack
                alignItems="center"
                gap={1}
                color="brand.500"
                cursor="pointer"
              >
                <Text>Edit</Text>
                <BiEdit />
              </HStack>
            </Flex>
          );
        })}
      </Stack>
    </Box>
  );
}
